export var defaultCreateModel = {
    ticketTypes: [],
    products: [],
    projects: [],
    competencies: []
};



//////////////////
// WEBPACK FOOTER
// ./src/models/TaskCreate.ts
// module id = 781
// module chunks = 0